import { useTranslation } from '@web_opxp/features';
import { Themes } from '../../../services/themeManager';
import { FacebookButton, GoogleButton } from '../../../social';

const componentWhiteListThemes = {
  [Themes.Edison]: true,
  [Themes.Opxp]: true,
};

interface Props {
  theme: Themes;
}

export default function SocialLogin({ theme }: Props) {
  const { t } = useTranslation();
  if (!componentWhiteListThemes[theme]) {
    return null;
  }
  return (
    <div className="mt-3">
      <p>{t('Social.Login')}</p>
      <div className="d-flex justify-content-between">
        <FacebookButton />
        <GoogleButton />
      </div>
    </div>
  );
}
